import React, { useEffect } from "react";
import Layout from "../components/layout/Layout";

export default function Repertory() {
  console.log("ProjectAlpha component rendered!");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-8xl font-light mb-12">
            Repertory
          </h1>

          <div className="space-y-12 text-lg text-gray-700 leading-relaxed">

            {/* SOLO SECTION */}
            <section>
              <h2 className="text-3xl font-light mb-6">Solo</h2>
              <ul className="space-y-2 list-disc list-inside">
                <li>BACH – 6 Sonatas and Partitas for Solo Violin, BWV 1001–1006</li>
                <li>BACH – Violin Concerto in A Minor, BWV 1041</li>
                <li>BARBER – Concerto for Violin & Orchestra, Op. 14</li>
                <li>BARTÓK – Violin Concerto No. 2, Sz. 112</li>
                <li>BEETHOVEN – Violin Sonata No. 5 in F Major, Op. 24</li>
                <li>BEETHOVEN – Violin Sonata No. 7 in C Minor, Op. 30, No. 2</li>
                <li>BEETHOVEN – Violin Sonata No. 8 in G Major, Op. 30, No. 3</li>
                <li>BEETHOVEN – Violin Sonata No. 10 in G Major, Op. 96</li>
                <li>BEETHOVEN – Violin Concerto in D Major, Op. 61</li>
                <li>BERNSTEIN – Serenade (after Plato’s Symposium)</li>
                <li>BRAHMS – Violin Concerto in D Major, Op. 77</li>
                <li>BRAHMS – Sonata for Violin and Piano No. 1 in G Major, Op. 78</li>
                <li>BRAHMS – Sonata for Violin and Piano No. 2 in A Major, Op. 100</li>
                <li>BRAHMS – Sonata for Violin and Piano No. 3 in D Minor, Op. 108</li>
                <li>BRUCH – Violin Concerto No. 1, Op. 26</li>
                <li>DEBUSSY – Sonata for Violin and Piano in G Minor</li>
                <li>ELGAR – Violin Concerto in B Minor, Op. 61</li>
                <li>ERNST – Variations on “The Last Rose of Summer”</li>
                <li>FAURÉ – Sonata for Violin and Piano No. 1 in A Major, Op. 13</li>
                <li>FRANCK – Sonata for Violin and Piano in A</li>
                <li>HAYDN – Violin Concerto in G Major, Hob. VIIa:4</li>
                <li>KORNGOLD – Violin Concerto in D Major, Op. 35</li>
                <li>MENDELSSOHN – Violin Concerto in E Minor, Op. 64</li>
                <li>MOZART – Violin Concerto No. 1 in B-Flat Major, K. 207</li>
                <li>MOZART – Violin Concerto No. 3 in G Major, K. 216</li>
                <li>MOZART – Violin Concerto No. 4 in D Major, K. 218</li>
                <li>MOZART – Violin Concerto No. 5 in A Major, K. 219</li>
                <li>MOZART – Sonata for Piano and Violin in B-Flat, K. 454</li>
                <li>PAGANINI – 24 Caprices for Solo Violin, Op. 1</li>
                <li>PROKOFIEV – Violin Concerto No. 1 in D Major, Op. 19</li>
                <li>SAINT-SAËNS – Introduction and Rondo Capriccioso, Op. 28</li>
                <li>SARASATE – Malagueña</li>
                <li>TAAFFE ZWILICH – Fantasy for Solo Violin</li>
                <li>TAKEMITSU – Hika</li>
                <li>TCHAIKOVSKY – Violin Concerto in D, Op. 35</li>
              </ul>
            </section>

            {/* CHAMBER SECTION */}
            <section>
              <h2 className="text-3xl font-light mb-6">Chamber</h2>
              <ul className="space-y-2 list-disc list-inside">
                <li>MALCOLM ARNOLD – Concerto for Two Violins and String Orchestra, Op. 77</li>
                <li>AMY BEACH – Theme and Variations for Flute and String Quartet, Op. 80</li>
                <li>BEETHOVEN – String Quartet No. 2 in G Major, Op. 18, No. 2</li>
                <li>BEETHOVEN – String Quartet No. 7 in F Major, Op. 59, No. 1</li>
                <li>BEETHOVEN – String Quartet No. 8 in E Minor, Op. 59, No. 2</li>
                <li>BEETHOVEN – Grosse Fuge, Op. 133</li>
                <li>BORODIN – String Quartet No. 2 in D Major</li>
                <li>BRAHMS – Piano Quintet in F Minor, Op. 34</li>
                <li>BRAHMS – String Quartet No. 2 in A Minor, Op. 51</li>
                <li>DVOŘÁK – Terzetto in C Major, Op. 74</li>
                <li>DVOŘÁK – String Quartet No. 12, Op. 96 ("American")</li>
                <li>GLAZUNOV – 5 Novelettes, Op. 15</li>
                <li>HAYDN – String Quartet in F Minor, Op. 55, No. 2 ("The Razor")</li>
                <li>HAYDN – String Quartet in C Major, Op. 76, No. 3 ("Emperor")</li>
                <li>KODÁLY – Duo for Violin and Cello, Op. 7</li>
                <li>MARTINŮ – Three Madrigals for Violin and Viola</li>
                <li>MENDELSSOHN – String Quartet No. 1 in E-flat Major, Op. 12</li>
                <li>MENDELSSOHN – String Quartet No. 3 in D Major, Op. 44, No. 1</li>
                <li>JESSIE MONTGOMERY – Starburst</li>
                <li>MOZART – String Quartet No. 14 in G Major, K. 387 ("Spring")</li>
                <li>MOZART – Duo for Violin & Viola in B-Flat Major, K. 424</li>
                <li>MOZART – Adagio and Fugue in C Minor, K. 546</li>
                <li>PIAZZOLLA – Four Seasons of Buenos Aires</li>
                <li>PROKOFIEV – String Quartet No. 2 in F, Op. 92</li>
                <li>RAVEL – String Quartet in F Major, M. 35</li>
                <li>SARASATE – Navarra, Op. 33</li>
                <li>SCHUBERT – Quartet No. 14 in D Minor, D. 810 ("Death and the Maiden")</li>
                <li>SCHUBERT – Quintet in A Major for Piano and Strings ("The Trout"), Op. post. 114</li>
                <li>CAROLINE SHAW – Valencia</li>
                <li>SHOSTAKOVICH – String Quartet No. 8 in C Minor, Op. 110</li>
                <li>SHOSTAKOVICH – String Quartet No. 2 in A Major, Op. 68</li>
                <li>VIVALDI – Concerto for Four Violins in B Minor, Op. 3</li>
                <li>VIVALDI – Four Seasons, Op. 8</li>
                <li>WEBERN – Langsamer Satz</li>
              </ul>
            </section>

          </div>
        </div>
      </div>
    </Layout>
  );
}